import React from 'react'
import clsx from 'clsx'

import { useBreakpoint } from '../../../providers/BreakpointProvider'
import useStyles from './styles'

type WidgetContainerProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  visible?: boolean
  variant: 'body' | 'header'
  numColumns?: number
}

const WidgetContainer: React.FC<WidgetContainerProps> = ({
  visible = true,
  variant,
  numColumns = 2,
  className,
  ...props
}) => {
  const { isMedium } = useBreakpoint()

  const classes = useStyles({ numColumns: isMedium ? 1 : numColumns })

  if (!visible) {
    return null
  }

  return <div className={clsx(classes[variant], className)} {...props} />
}

export default WidgetContainer
